import { Button, Table } from "antd";
import { CarrierName } from "../../ShippingPreferencesSection";
import { MinusCircleFilled, PlusCircleFilled } from "@ant-design/icons";
import React from "react";

interface ShippingDrawerTableProps {
  drawerCarriers: CarrierName[];
  removePreference: (carrierName: CarrierName) => void;
  addCarrierFilter: (carrierName: string) => void;
  selectChange: (selectedValue: string, carrierName: string) => void;
  whitelisted: string[];
  blacklisted: string[];
}

const ShippingPreferencesDrawerTable: React.FC<ShippingDrawerTableProps> = ({
  drawerCarriers,
  removePreference,
  addCarrierFilter,
  selectChange,
  whitelisted,
  blacklisted,
}) => {
  const buildDrawerColumns = () => {
    return [
      {
        title: "Carrier Name",
        key: "carrier_name",
        render: (_: string, carrierName: CarrierName) => <>{carrierName.carrierName}</>,
        width: "33%",
      },
      {
        key: "preference",
        width: "33%",
        render: renderDrawerPreferenceSelect,
      },
    ];
  };
  const renderDrawerPreferenceSelect = (_: string, carrierName: CarrierName) => {
    let status = "";
    if (whitelisted.includes(carrierName.carrierName)) {
      status = "Prefer";
    } else if (blacklisted.includes(carrierName.carrierName)) {
      status = "Exclude";
    }

    return (
      <Button
        type="link"
        danger={status !== "" ? true : false}
        icon={status === "" ? <PlusCircleFilled /> : <MinusCircleFilled />}
        onClick={() => {
          switch (status) {
            case "Prefer":
            case "Exclude":
              removePreference(carrierName);
              break;
            case "":
              addCarrierFilter(carrierName.carrierName);
              selectChange("Prefer", carrierName.carrierName);
              break;
          }
        }}
      >
        {status === "" ? "Add Preference" : "Remove Preference"}
      </Button>
    );
  };
  return <Table dataSource={drawerCarriers} columns={buildDrawerColumns()} pagination={false} />;
};

export default ShippingPreferencesDrawerTable;
